import React from "react";
import PropTypes from "prop-types";
const BookmarkStandardisedIcon = ({
  noPointer,
  className,
  width,
  size,
  height,
  style,
  color,
  title
}) => (
  <svg
    className={className}
    style={style}
    data-no-pointer={noPointer}
    width={width || size || 20}
    height={height || size || 20}
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="title"
    fill={color || "var(--color-easil-gray-x-dark)"}
  >
    <title>{title}</title>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M6 2a2 2 0 0 0-2 2v13.826l6-5.143 6 5.143V4a2 2 0 0 0-2-2H6zm4 13.317l-4.698 4.027A2 2 0 0 1 2 17.826V4a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v13.826a2 2 0 0 1-3.302 1.518L10 15.317z"
        fill={color || "var(--color-easil-gray-x-dark)"}
        fillRule="nonzero"
      />
    </g>
  </svg>
);
BookmarkStandardisedIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  size: PropTypes.string,
  height: PropTypes.string,
  style: PropTypes.object,
  color: PropTypes.string
};

export default BookmarkStandardisedIcon;
